var render = function () {
  var _vm$company, _vm$company2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.company,
      expression: "!company"
    }],
    attrs: {
      "color": "white",
      "absolute": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "width": "5",
      "size": "100",
      "color": "primary"
    }
  })], 1)], 1), _c('company-view-heading', _vm._b({
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        return [_c('like-btn', {
          attrs: {
            "params": _vm.likeParams
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref) {
              var active = _ref.active,
                toggle = _ref.toggle;
              return [_c('v-btn', {
                staticClass: "like-btn",
                attrs: {
                  "icon": "",
                  "text": "",
                  "outlined": "",
                  "color": active ? 'yellow darken-1' : 'grey-c'
                },
                on: {
                  "click": toggle
                }
              }, [_c('v-icon', {
                attrs: {
                  "color": active ? undefined : 'grey-9'
                }
              }, [_vm._v(_vm._s(active ? "mdi-star" : "mdi-star-outline"))])], 1)];
            }
          }])
        })];
      },
      proxy: true
    }])
  }, 'company-view-heading', {
    company: _vm.company
  }, false)), _c('v-divider', {
    staticClass: "border-2 primary my-16 my-lg-20"
  }), _c('div', {
    staticClass: "page-section"
  }, [_c('h5', {
    staticClass: "page-text page-text--lg mb-8 mb-lg-16"
  }, [_vm._v("채용중인 공고")]), _vm.company ? _c('company-view-recruitments', {
    attrs: {
      "params": _vm.recruitmentsParams
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "page-section"
  }, [_c('h5', {
    staticClass: "page-text page-text--lg mb-8 mb-lg-16"
  }, [_vm._v("기업/서비스 소개")]), _vm.company ? _c('company-view-introduction-images', _vm._b({
    staticClass: "mb-16 mb-lg-20",
    attrs: {
      "multiple": ""
    }
  }, 'company-view-introduction-images', (_vm$company = _vm.company) === null || _vm$company === void 0 ? void 0 : _vm$company.introduction, false)) : _vm._e(), _c('company-view-introduction-content', _vm._b({
    attrs: {
      "expanded": ""
    }
  }, 'company-view-introduction-content', (_vm$company2 = _vm.company) === null || _vm$company2 === void 0 ? void 0 : _vm$company2.introduction, false))], 1), _c('h5', {
    staticClass: "page-text page-text--lg mb-8 mb-lg-16"
  }, [_vm._v("주소")]), _c('p', {
    staticClass: "page-text line-height-15"
  }, [_vm._v(_vm._s(_vm.address))]), _c('v-responsive', {
    staticClass: "mt-12 mt-lg-16",
    attrs: {
      "aspect-ratio": 16 / 9
    }
  }, [_c('company-view-location-map', _vm._b({}, 'company-view-location-map', {
    company: _vm.company
  }, false))], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }